module.exports = __webpack_public_path__ + "fonts/fa-duotone-900.f7d52eee.eot";